module.exports = __webpack_public_path__ + "static/media/Ellipsis-3s-90px.2fcfbe03.svg";